export default class SearchItem {
    regionId: number = null;
    teeDate: Date = null;
    teeTime: number = null;
    keyWord: string = "";
}